import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";
import { ReportVo } from "src/vo/reportVo";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 1-1. initial state 객체 생성
const initialState: ReportVo = {
  progress: 0,
};

export const reportAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  tagTypes: ["ReportVo"],
  reducerPath: "reportAPI",
  endpoints: (builder) => ({
    //  ========================= 완료 보고 상세 화면 =========================
    reportDetail: builder.query({
      query: (as_idx) => ({
        url: `/as/${as_idx}/completion-report`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        providesTags: ["ReportVo"],
      }),
      transformResponse: (response: any) => response.data,
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
    // ========================= 완료 보고 등록 =========================
    addReport: builder.mutation({
      query: (formData) => ({
        url: `/as/${formData.get("as_idx")}/completion-report`,
        method: "POST",
        headers: {},
        body: formData,
      }),
    }),
    updateReport: builder.mutation({
      query: (formData) => ({
        url: `/as/${formData.get("as_idx")}/completion-report`,
        method: "PUT",
        headers: {},
        body: formData,
      }),
    }),
    reportApprove: builder.mutation({
      query: (as_idx) => ({
        url: `/as/${as_idx}/completion-report/approve`,
        method: "PUT",
        headers: {},
      }),
    }),
    // ========================= 완료 보고 보완요청 =========================
    reportApproveReject: builder.mutation<void, Pick<ReportVo, "as_idx"> & Partial<ReportVo>>({
      query: ({ as_idx, ...data }) => ({
        url: `/as/${as_idx}/completion-report/reject`,
        method: "PUT",
        headers: {},
        body: data,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
// export const { useAsTestQuery } = asListAPI;

export const { useReportDetailQuery, useAddReportMutation, useReportApproveMutation, useReportApproveRejectMutation, useUpdateReportMutation } = reportAPI;
